export default (repositories) => {
    const list = repositories.list;
    const vcsList = Object.keys(list);
    let emptyVcsCount = 0;
    for (const vcs of vcsList) {
        if (Object.keys(list[vcs]).length === 0) {
            emptyVcsCount++;
        }
    }
    return emptyVcsCount === vcsList.length;
};
